/* eslint-disable no-template-curly-in-string */
/* eslint sort-keys: 'error' */
export default {
  'govhub.ebilling': 'E-Billing',
  'govhub.forms': 'Forms',
  'govhub.login': 'Log In',
  'govhub.logout': 'Log Out',
  'govhub.settings': 'Settings',
}
